<template>
  <el-container class="layout">
    <el-aside width="200px" class="aside">
      <div class="brand">
        <img style="width:40p;height:40px;margin-right:10px" src="/images/logo.png" alt="logo">
        爆品直播精选
      </div>
      <el-menu :default-active="active" router class="menu">
        <el-menu-item index="/overview">
          <i class="el-icon-s-data"></i>
          <span slot="title">补贴概览</span>
        </el-menu-item>
        <el-menu-item index="/products">
          <i class="el-icon-s-goods"></i>
          <span slot="title">直播间列表</span>
        </el-menu-item>
        <el-menu-item index="/orders">
          <i class="el-icon-s-order"></i>
          <span slot="title">我的订单</span>
        </el-menu-item>
        <el-menu-item index="/settlements">
          <i class="el-icon-money"></i>
          <span slot="title">提现与收益</span>
        </el-menu-item>
        <el-submenu index="sub-agent">
          <template slot="title">
            <i class="el-icon-s-grid"></i>
            <span>下级代理</span>
          </template>
          <el-menu-item index="/sub-orders">代理订单</el-menu-item>
          <el-menu-item index="/sub-users">代理列表</el-menu-item>
        </el-submenu>
        <el-submenu v-if="me.role === 'admin'" index="admin">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>后台管理</span>
          </template>
          <el-menu-item index="/settings">系统设置</el-menu-item>
          <el-menu-item index="/withdrawals">提现列表</el-menu-item>
          <el-menu-item index="/users">用户列表</el-menu-item>
          <el-menu-item index="/all-orders">用户订单</el-menu-item>
        </el-submenu>
        <el-menu-item index="/profile">
          <i class="el-icon-user-solid"></i>
          <span slot="title">用户信息</span>
        </el-menu-item>
        <el-menu-item index="/tutorial">
          <i class="el-icon-s-help"></i>
          <span slot="title">使用教程</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header">
        <div class="spacer"></div>
        <div class="user">
          <!-- <el-avatar :size="32" src="/images/user.png" /> -->
          <div class="user-avatar">
            <img src="/images/user.png" alt="">
          </div>
          <span class="phone">{{ me.phone || "" }}</span>
          <el-button type="primary" size="small" @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import api from "../api";

export default {
  name: "Layout",
  data() {
    return {
      me: {},
      active: this.$route.path,
    };
  },
  watch: {
    $route(to) {
      this.active = to.path;
    },
  },
  async created() {
    try {
      const { data } = await api.get("/api/users/me");
      this.me = data;
      // 保存用户角色到本地存储，用于路由权限检查
      localStorage.setItem("user_role", data.role || "");
    } catch (e) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_role");
      this.$router.replace("/login");
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_role");
      this.$router.replace("/login");
    },
  },
};
</script>

<style scoped>
.layout {
  height: 100%;
  min-width: 1080px;
}
.aside {
  color: #fff;
  background-color: rgba(29, 29, 29, 0.95);
}
.brand {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  font-weight: 700;
  background: #333854;
  color: #fff;
}
.menu {
  border-right: 0;
  background: none;
}
.menu >>> .el-menu-item,
.menu >>> .el-submenu__title {
  color: #fff;
}
.menu >>> .el-menu {
  background: none;
}
.menu >>> .el-menu-item:focus,
.menu >>> .el-menu-item:hover,
.menu >>> .el-submenu__title:focus,
.menu >>> .el-submenu__title:hover {
  background: none;
  color: #409eff;
}
.menu >>> .el-menu-item.is-active {
  background-color: #409eff;
  color: #fff;
}

.menu >>> .el-submenu__icon-arrow {
  font-size: 14px;
  margin-top: -4px;
}
.header {
  background: #333854;
  display: flex;
  align-items: center;
}
.spacer {
  flex: 1;
}
.user {
  display: flex;
  align-items: center;
  gap: 10px;
}
.phone {
  color: #fff;
}
.main {
  padding: 18px;
}
.user-avatar{
  width: 32px;
  height: 32px;
  background: #eee;
  border-radius: 999px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-avatar img{
  width: 24px;
  height: 24px;
}
</style>
<style>
.main > .el-card {
  min-height: 99%;
}
</style>
